// extracted by mini-css-extract-plugin
export default {"Link":"SupportLink_Link__5Aish","LinkUnderlined":"SupportLink_LinkUnderlined__oySC5","Icon":"SupportLink_Icon__Txoln"};